import { NgModule } from '@angular/core';

import { CmpsProgressBarComponent } from './progress-bar.component';

@NgModule({
    declarations: [CmpsProgressBarComponent],
    exports: [CmpsProgressBarComponent],
    imports: [],
})
export class CmpsProgressBarModule {}
